<template>
  <div class="auditPage">
    <div class="pass" v-if="passInfo">
      <el-row class="centerIE">
        <el-col :span="4"><i class="el-icon-check"></i></el-col>
      </el-row>
      <el-row>
        <el-col>
          <p class="center">报名信息已提交，正在进行信息审核，请耐心等待</p>
          <el-button type="danger" @click="updataFormHandle('change')">修改报名信息</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="faile" v-else>
      <el-row class="centerIE">
        <el-col :span="4" class="ieNone"><i class="el-icon-circle-close"></i></el-col>
      </el-row>
      <el-row>
        <el-col>
          <p>信息审核未通过请重新填写报名信息!</p>
        </el-col>
        <el-col class="failMessage">失败原因：{{ failInfo }}</el-col>
        <el-col><el-button type="primary" @click="updataFormHandle">修改报名信息</el-button></el-col>
      </el-row>
    </div>
    <formCard />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import formCard from '../components/formCard'
export default {
  components: {
    formCard
  },
  data() {
    return {
      // passInfo: true
    }
  },
  computed: {
    ...mapState(['passInfo', 'failInfo'])
  },
  methods: {
    updataFormHandle(val) {
      if (val == 'change') {
        const queryData = {
          ...this.$route.query,
          set: val
        }
        this.$router.push({ path: '/ApplyUpdataForm', query: queryData })
      } else {
        const queryData = this.$route.query
        // console.log("queryData",queryData)
        this.$router.push({ path: '/ApplyUpdataForm', query: queryData })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/style/mixin.scss';
.auditPage {
  height: 100%;
  .pass,
  .faile {
    i {
      font-size: 80px;
      margin-top: 50px;
      margin-bottom: 18px;
    }
    p {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      font-size: 28px;
      line-height: 50px;
    }
  }
  .pass {
    color: #409efe;
  }
  .faile {
    margin-top: 100px\0;
    color: #f56c6c;
    margin-bottom: 20px;
    p {
      // display: flex;
      // justify-content: center;
      // align-items: center;
      text-align: center;
    }
    .el-button {
      margin-left: 20px;
    }
    .failMessage {
      text-align: center;
      font-size: 24px;
      line-height: 34px;
      margin: 20px 0;
    }
  }

  @include autoInner;
}
// icon居中
.centerIE {
  transform: translate(45%);
}
.ieNone {
  display: none\0;
}
</style>
